import React, { useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import {
  Tabs,
} from 'antd';
import {
  myLeadsHeaderAtom,
} from '../../../../../atoms/Atoms';
import {
  thousand,
} from '../../../../../functions';
import LeadsSearchTable from './LeadsSearchTable';

function LeadsLost({ className, orgReferral, useGlobal, isSetter }) {
  const { t } = useTranslation();
  const myLeadsHeader = useRecoilValue(myLeadsHeaderAtom);
  const { TabPane } = Tabs;
  const [selectedTab, setSlectedTab] = useState('disengaged');

  return (
    <div className={className}>
      <Tabs activeKey={selectedTab} onChange={(tab) => setSlectedTab(tab)}>
        <TabPane key="disengaged" tab={`${t('disengaged')} (${thousand(myLeadsHeader?.totalLostDisengaged)})`}>
          {selectedTab === 'disengaged' && (
            <LeadsSearchTable orgReferral={orgReferral} useGlobal={useGlobal} isSetter={isSetter} searchType={11} />
          )}
        </TabPane>
        <TabPane key="failed_credit" tab={`${t('failed_credit')} (${thousand(myLeadsHeader?.totalLostFailedCredit)})`}>
          {selectedTab === 'failed_credit' && (
            <LeadsSearchTable orgReferral={orgReferral} useGlobal={useGlobal} isSetter={isSetter} searchType={12} />
          )}
        </TabPane>
        <TabPane key="cancelled" tab={`${t('cancelled')} (${thousand(myLeadsHeader?.totalLostCancelled)})`}>
          {selectedTab === 'cancelled' && (
            <LeadsSearchTable orgReferral={orgReferral} useGlobal={useGlobal} isSetter={isSetter} searchType={13} />
          )}
        </TabPane>
      </Tabs>
    </div>
  );
}

export default LeadsLost;
